import React from 'react'
import Hero from './utilities/Hero'
import PopularRoom from './utilities/PopularRoom'

function Home() {
    return (
        <div>
            <Hero />
            <PopularRoom />
        </div>
    )
}

export default Home
